import styled from 'styled-components';

import UModal from 'components/Modal';

export const Modal = styled(UModal)`
  width: 360px;
`;
